export enum LabelSizes {
  "x4" = "x4",
  "x6" = "x6",
  "x8" = "x8",
}
